module.exports = __webpack_public_path__ + "img/深圳大运文化艺术公园.b4135194.png";